module.exports = __webpack_public_path__ + "media/images/icons/outlined/contacts-c9596c9750d9e36236df3ce39feb58bc.svg";